import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e2b2255e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "animate main-box" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "animate conversation-header" }
const _hoisted_5 = {
  key: 0,
  style: {"color":"white"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"60px"} }, null, -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "friend-dialog-container"
}
const _hoisted_9 = { class: "animate friend-dialog" }
const _hoisted_10 = { style: {"color":"#333","font-size":"10px"} }
const _hoisted_11 = { style: {"margin-top":"5px","margin-bottom":"5px"} }
const _hoisted_12 = { style: {"color":"#333","font-size":"10px"} }
const _hoisted_13 = {
  key: 1,
  class: "my-dialog-container"
}
const _hoisted_14 = { class: "animate my-dialog" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { style: {"color":"#333","font-size":"10px"} }, "Yo:", -1))
const _hoisted_16 = { style: {"margin-top":"5px","margin-bottom":"5px"} }
const _hoisted_17 = { style: {"color":"#333","font-size":"10px"} }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"200px"} }, null, -1))
const _hoisted_19 = { class: "type-text" }

import { ref, onMounted, onUnmounted, computed } from 'vue'
import FriendshipService from '@/services/FriendshipService'
import { useAuth } from '@/store/useAuth'



export default /*#__PURE__*/_defineComponent({
  __name: 'FullConversationChat',
  props: ['friendId'],
  emits: ['closeConversation'],
  setup(__props, { emit: __emit }) {

const props = __props
const conversation = ref()
const friendshipService = new FriendshipService()
const store = useAuth()
const loading = ref(true)
const objDiv = ref()
const emit = __emit
const message = ref('')
const firsTime = ref(true)

const intervalId = window.setInterval(async () => {
    if (!store.token) {
        return
    }
    friendshipService.getConversation(store.token, props.friendId)
    if(firsTime.value) {
        objDiv.value.scrollIntoView({ behavior: 'smooth', block: 'end' });
        firsTime.value=false;
    }
}, 2000)

onMounted(async () => {
    if (!store.token) { 
        loading.value = false
        return 
    }
    loading.value = true
    conversation.value = await friendshipService.getConversation(store.token, props.friendId)
    if (objDiv.value) {
        objDiv.value.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
    loading.value = false
})

onUnmounted(() => {
    clearInterval(intervalId);
})

const sendMessage = async () => {
    if (!store.token) {
        return
    }
    await friendshipService.sendMessage(store.token, props.friendId, message.value)
    conversation.value = await friendshipService.getConversation(store.token, props.friendId)
    objDiv.value.scrollIntoView({ behavior: 'smooth', block: 'end' });
    message.value = ''
}

const markAsRead = async () => {
    if(!store.token) {
        return
    }
    friendshipService.markAsRead(store.token, props.friendId)
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_icon, {
            name: "ri-loader-2-fill",
            animation: "spin",
            class: "icon",
            scale: "2"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (conversation.value)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_5, _toDisplayString(conversation.value.user.name), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_v_icon, {
              name: "ri-close-circle-fill",
              scale: "1.5",
              fill: "white",
              animation: "wrench",
              hover: "true",
              style: {"cursor":"pointer"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('closeConversation')))
            })
          ]),
          _hoisted_6,
          _createElementVNode("div", {
            style: {"overflow-y":"scroll"},
            ref_key: "objDiv",
            ref: objDiv
          }, [
            (conversation.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conversation.value.messages, (message) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: message.id
                    }, [
                      (message.sender == props.friendId)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("small", _hoisted_10, _toDisplayString(conversation.value.user.name) + ":", 1),
                              _createElementVNode("p", _hoisted_11, _toDisplayString(message.message), 1),
                              _createElementVNode("small", _hoisted_12, _toDisplayString(new Date(message.created_at).getHours()) + ":" + _toDisplayString(new Date(message.created_at).getMinutes()) + " " + _toDisplayString(new Date(message.created_at).getDate()) + "/" + _toDisplayString(new Date(message.created_at).getMonth()+1) + "/" + _toDisplayString(new Date(message.created_at).getFullYear()), 1)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _hoisted_15,
                              _createElementVNode("p", _hoisted_16, _toDisplayString(message.message), 1),
                              _createElementVNode("small", _hoisted_17, _toDisplayString(new Date(message.created_at).getHours()) + ":" + _toDisplayString(new Date(message.created_at).getMinutes()) + " " + _toDisplayString(new Date(message.created_at).getDate()) + "/" + _toDisplayString(new Date(message.created_at).getMonth()+1) + "/" + _toDisplayString(new Date(message.created_at).getFullYear()), 1)
                            ])
                          ]))
                    ]))
                  }), 128)),
                  _hoisted_18
                ]))
              : _createCommentVNode("", true)
          ], 512),
          _createElementVNode("div", _hoisted_19, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Escribir mensaje...",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((message).value = $event)),
              onKeyup: _withKeys(sendMessage, ["enter"]),
              onFocus: markAsRead,
              max: "255"
            }, null, 544), [
              [_vModelText, message.value]
            ]),
            _createElementVNode("button", { onClick: sendMessage }, "Enviar")
          ])
        ]))
  ]))
}
}

})